import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar } from "lucide-react";
import "./style/article.css";

const Article = (props) => {
	const { date, title, description, link } = props;

	return (
		<div className="article">
			<div style={{ display: "flex", alignItems: "center", gap: "6px" }} className="article-date">
				<Calendar size={14} />
				<span>{date}</span>
			</div>

			<Link to={link} style={{ textDecoration: "none" }}>
				<h3 className="article-title">{title}</h3>
				<p className="article-description">{description}</p>
				<div className="article-link">
					<span>Read article</span>
					<ArrowRight size={14} />
				</div>
			</Link>
		</div>
	);
};

export default Article;
